import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Empty } from 'antd';
import { SaleWrapper, EmptyWrapper } from './Services.styled';
import { Text, FlexDivCenter } from '../../components/Typography/Typography';
import Product from '../../components/Product/Product';
import useMedia from '../../customHooks/UseMedia';

export default () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { activeUser } = useSelector((store) => store.auth);
  const { products } = useSelector((store) => store.products);
  const { isMobile } = useMedia();
  const history = useHistory();
  function getProducts() {
    return products
      .filter((p) => p.displayInStore && p.type === 'sg_services')
      .filter((p) => {
        if (p.membersOnly && activeUser.membershipStatus !== 'MEMBER') {
          return false;
        }
        return true;
      });
  }
  return (
    <SaleWrapper className="animate__animated animate__fadeIn">
      <FlexDivCenter style={{ margin: '30px 0' }}>
        <div
          style={{
            background: 'white',
            border: '1px solid #1D3E7E',
            boxShadow: '-1px -2px 16px -5px rgba(0,0,0,0.83)',
            width: 400,
            padding: 10,
            borderRadius: 3,
          }}
        >
          <FlexDivCenter>
            <Text bold size="xxlarge">
              {t('hi', { name: activeUser.fullname })}
            </Text>
          </FlexDivCenter>
          <FlexDivCenter>
            <Text size="large">{t('service_welcome_title')}</Text>
          </FlexDivCenter>
        </div>
      </FlexDivCenter>
      <FlexDivCenter>
        <FlexDivCenter style={{ maxWidth: 1400 }}>
          {getProducts().length === 0 ? (
            <EmptyWrapper>
              <Empty
                description={
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t('no_data_to_display', {
                        data: t('sg_services'),
                      }),
                    }}
                  />
                }
              />
            </EmptyWrapper>
          ) : (
            getProducts().map((product) => <Product {...product} />)
          )}
        </FlexDivCenter>
      </FlexDivCenter>
    </SaleWrapper>
  );
};
